import { render, staticRenderFns } from "./InputDefaultValue.vue?vue&type=template&id=64c10a9e&scoped=true&"
import script from "./InputDefaultValue.vue?vue&type=script&lang=js&"
export * from "./InputDefaultValue.vue?vue&type=script&lang=js&"
import style0 from "./InputDefaultValue.vue?vue&type=style&index=0&id=64c10a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c10a9e",
  null
  
)

export default component.exports